import { useState, useEffect } from 'react';
import { Calendar, HandPlatter, ChevronRight } from 'lucide-react';
import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import { Link } from 'react-router-dom';

const ICON_MAP = {
  calendar: <Calendar size={22} />,
  handPlatter: <HandPlatter size={22} />,
};

export default function UpcomingEventsButton({
  label = 'Upcoming House Events',
  icon = 'calendar',
  itemCount,
  path = '/events/calendar',
}) {
  const [count, setCount] = useState(null);

  useEffect(() => {
    setCount(itemCount);
  }, [itemCount]);

  return (
    <Button variant="outline" className="px-2">
      <Link to={path} className="flex items-center gap-1">
        {/* Icon */}
        <span className="flex h-5 w-5 items-center justify-center transition-colors duration-150">
          {ICON_MAP[icon]}
        </span>

        {/* Text */}
        <div className="flex items-center justify-center text-xs font-medium uppercase">
          {label}:
        </div>

        {/* Count */}
        {count === null ? (
          <span className="h-[1.35rem] w-[1.35rem] animate-pulse rounded-2xl bg-slate-300">
            -
          </span>
        ) : (
          <span
            className={`flex h-[1.35rem] min-w-[1.35rem] items-center justify-center rounded-full bg-[#CAAB6A] px-1 text-xs font-bold text-white tabular-nums`}
          >
            {count > 99 ? '99+' : count}
          </span>
        )}

        {/* Arrow */}
        <ChevronRight size={22} />
      </Link>
    </Button>
  );
}
